import { useEffect, useState } from 'react';

import { authStorage } from 'utils/storage';

export function useSubscriptionAccess() {
  const [hasSubscriptionAccess, setHasSubscriptionAccess] = useState(authStorage.hasActiveSubscription());

  useEffect(() => {
    const updateSubscription = () => setHasSubscriptionAccess(authStorage.hasActiveSubscription());

    window.addEventListener('storage', updateSubscription);
    window.addEventListener('subscription-change', updateSubscription);
    window.addEventListener('auth-change', updateSubscription);

    return () => {
      window.removeEventListener('storage', updateSubscription);
      window.removeEventListener('subscription-change', updateSubscription);
      window.removeEventListener('auth-change', updateSubscription);
    };
  }, []);

  return hasSubscriptionAccess;
}
